// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4104":"4a9a6ba6","5219":"69c965a0"}[chunkId] + ".chunk.css";
};